import * as React from "react";
import { SVGProps, memo } from "react";

const SvgMemo = (props: SVGProps<SVGSVGElement>) => (
  <svg width={64} height={88} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M49.042 49.218s-2.099-.697-3.992-1.716c-.55-.295-1.509-1.21-1.793-1.723a5.062 5.062 0 0 1-.55-1.501c-.572-2.922-.173-6.132-.173-6.132s-2.302-1.417-3.966-1.447h-.17c-1.664.026-3.966 1.447-3.966 1.447s.114 3.228-.174 6.132c-.037.358-.217.893-.55 1.501-.283.517-1.243 1.428-1.792 1.723-1.89 1.019-3.993 1.716-3.993 1.716-.808.358-1.523 1.834-1.129 3.217.54 1.904 1.823 2.266 3.28 2.68.384.106.768.224 1.37.328 2.508.428 5.135.87 7.043.63 1.907.24 4.534-.206 7.043-.63.605-.104.985-.222 1.369-.329 1.457-.413 2.741-.775 3.28-2.678.39-1.384-.321-2.86-1.13-3.218h-.007Z"
      fill="#fff"
    />

    <path
      d="M49.042 49.218s-2.099-.697-3.992-1.716c-.55-.295-1.509-1.21-1.793-1.723a5.062 5.062 0 0 1-.55-1.501c-.572-2.922-.173-6.132-.173-6.132s-2.302-1.417-3.966-1.447h-.17c-1.664.026-3.966 1.447-3.966 1.447s.114 3.228-.174 6.132c-.037.358-.217.893-.55 1.501-.283.517-1.243 1.428-1.792 1.723-1.89 1.019-3.993 1.716-3.993 1.716-.808.358-1.523 1.834-1.129 3.217.54 1.904 1.823 2.266 3.28 2.68.384.106.768.224 1.37.328 2.508.428 5.135.87 7.043.63 1.907.24 4.534-.206 7.043-.63.605-.104.985-.222 1.369-.329 1.457-.413 2.741-.775 3.28-2.678.39-1.384-.321-2.86-1.13-3.218h-.007Z"
      stroke="#272C33"
      strokeWidth={1.354}
      strokeLinecap="round"
      strokeLinejoin="round"
    />

    <path
      d="M27.868 50.087c5.74.601 11.596.605 17.322-.052-.004.022-.007.04-.007.155 1.981 1.886 3.38 4.103 4.05 6.435.215.738.355 1.483.495 2.228.244 1.28.483 2.561.727 3.841.2 1.052.395 2.1.557 3.155.893 5.852.638 11.77 1.557 17.636-.107.111-.048.284.126.332 0 .011-.008.023-.067.008-2.1.627-4.416.7-6.678.767-3.143.092-6.283.185-9.427.273-2.003.06-4.01.118-6.006-.007-3.365-.21-6.623-.934-9.851-1.657a57.709 57.709 0 0 1 1.044-12.474c.86-4.435 2.24-8.811 2.94-13.26.189-1.204.333-2.421.779-3.587.502-1.314 1.38-2.528 2.439-3.8v.007Z"
      fill="#CAECD1"
      stroke="#272C33"
      strokeWidth={1.162}
      strokeLinecap="round"
      strokeLinejoin="round"
    />

    <path
      d="M28.48 49.705s.229-1.221-1.173-.594c-.893.398-3.889 2.39-3.889 2.39a22.307 22.307 0 0 0-6.755 8.911c-.712 1.712-1.207 3.505-1.698 5.295-1.328 4.826-3.401 13.29-2.66 16.297.34 1.383 12.556 3.39 13.043 1.177.476-2.148.753-5.63.753-5.63"
      fill="#fff"
    />

    <path
      d="M28.48 49.705s.229-1.221-1.173-.594c-.893.398-3.889 2.39-3.889 2.39a22.307 22.307 0 0 0-6.755 8.911c-.712 1.712-1.207 3.505-1.698 5.295-1.328 4.826-3.401 13.29-2.66 16.297.34 1.383 12.556 3.39 13.043 1.177.476-2.148.753-5.63.753-5.63"
      stroke="#272C33"
      strokeWidth={1.354}
      strokeLinecap="round"
      strokeLinejoin="round"
    />

    <path
      d="M26.104 77.546c.18-1.867.45-3.62.635-5.523.87-8.962 2.615-18.028 5.493-25.326-.601.17-1.66.45-2.217.668-.709.277-1.598.56-1.797.709-.457.346-5.612 8.113-6.567 9.574-.1.155-.203.317-.229.498-.033.218-.03.476.114.646.476.568 1.233 1.487 2.266 2.501-1.044 1.022-1.277 1.296-2.2 2.214-.11.11-.398.436-.468.576-.092.192-.022.39-.007.446.107.388 1.793 6.959 3.575 12.294"
      fill="#fff"
    />

    <path
      d="M26.104 77.546c.18-1.867.45-3.62.635-5.523.87-8.962 2.615-18.028 5.493-25.326-.601.17-1.66.45-2.217.668-.709.277-1.598.56-1.797.709-.457.346-5.612 8.113-6.567 9.574-.1.155-.203.317-.229.498-.033.218-.03.476.114.646.476.568 1.233 1.487 2.266 2.501-1.044 1.022-1.277 1.296-2.2 2.214-.11.11-.398.436-.468.576-.092.192-.022.39-.007.446.107.388 1.793 6.959 3.575 12.294"
      stroke="#272C33"
      strokeWidth={1.354}
      strokeLinecap="round"
      strokeLinejoin="round"
    />

    <path
      d="M57.148 82.049c-2.03 6.634-15.338 6.232-21.115.989-4.978-4.516-4.254-11.862-4.07-13.748 1.026-10.4 12.858-20.005 17.046-19.577 9.01.922 10.998 22.986 8.139 32.336Z"
      fill="#fff"
    />

    <path
      d="M47.603 65.883c-.292 3.457-1.413 7.482-1.745 15.644-.244 5.94-17.817 5.575-17.983 2.047-.026-.568.62-5.711.62-5.737 0 0 8.172-22.909 15.902-33.148.97.225.826.886 1.45 1.244.22.129.24 2.188.269 2.442.166 1.428-.613 1.886-.262 3.635.34 1.712-.82 5.988-1.262 8.014-.04.18-.122.608-.177.785-.063.21-.2.41-.384.535-.952.657-3.807.665-4.789 1.144.27.524.277 1.712.723 3.166.045.151.126.343.126.498 0 .151-.07.303-.185.406-3.217 2.811-8.294 8.099-9.747 10.7"
      fill="#fff"
    />

    <path
      d="M47.603 65.883c-.292 3.457-1.413 7.482-1.745 15.644-.244 5.94-17.817 5.575-17.983 2.047-.026-.568.62-5.711.62-5.737 0 0 8.172-22.909 15.902-33.148.97.225.826.886 1.45 1.244.22.129.24 2.188.269 2.442.166 1.428-.613 1.886-.262 3.635.34 1.712-.82 5.988-1.262 8.014-.04.18-.122.608-.177.785-.063.21-.2.41-.384.535-.952.657-3.807.665-4.789 1.144.27.524.277 1.712.723 3.166.045.151.126.343.126.498 0 .151-.07.303-.185.406-3.217 2.811-8.294 8.099-9.747 10.7"
      stroke="#272C33"
      strokeWidth={1.354}
      strokeLinecap="round"
      strokeLinejoin="round"
    />

    <path d="M44.858 47.873c1.553.664 3.535 2.365 4.32 2.874l-4.32-2.874Z" fill="#fff" />

    <path
      d="M44.858 47.873c1.553.664 3.535 2.365 4.32 2.874M50.632 49.291c2.207 2.118 3.553 3.158 5.41 6.435.372.657 1.335 3.24 1.755 6.42.772 5.814.178 15.6-.214 18.846"
      stroke="#272C33"
      strokeWidth={1.354}
      strokeLinecap="round"
      strokeLinejoin="round"
    />

    <path
      d="M39.955 52.918c-3.258 1.93-2.793 6.556.453 7.73C38 52.397 51.986 54.67 50.824 44.648c-.214-1.845-.251-4.236-3.221-7.833-.893-1.395-2.39-.35-1.727.87.845 2.912-2.944 6.73-5.058 8.1-3.084 1.35-4.667 4.328-3.03 7.357-.165.044-.184 2.955.392 3.39"
      fill="#2BA168"
    />

    <path
      d="M45.695 2.87a21.334 21.334 0 0 0-16.4.126l.015.015c-1.465.273-4.649 1.074-7.405 3.749-3.863 3.748-4.206 8.563-4.32 10.198-.27 3.796.811 6.6 2.376 10.663 1.45 3.767 2.31 5.995 4.066 7.826 5.375 5.604 15.403 3.545 17.141 3.161 1.458.019 4.904-.136 8.346-2.346 3.745-2.406 5.243-5.808 5.877-7.306 3.365-7.929-.369-15.651-1.206-17.27-2.177-4.214-5.291-6.838-7.468-8.313-.34-.166-.679-.336-1.018-.502h-.004Z"
      fill="#2BA168"
    />

    <path
      d="M37.501 53.429c-.708-1.214-.804-2.845-.288-4.166.44-1.121 1.639-2.014 2.646-2.653 1.84-1.158 3.416-2.129 4.634-3.863 1.214-1.73 1.83-3.132 1.365-4.733 0 0 .037.014.804-.425 1.11-.638 1.092-.538 1.092-.538 3.092 3.623 3.373 6.128 3.38 8.002.007 1.875-.432 4.14-1.823 5.38-1.143 1.022-2.261 1.948-3.66 2.56-1.42.628-2.047 1.056-3.276 2.015-1.044.815-1.77 1.778-2.173 3.055-.402 1.277.188 2.996.188 2.996-1.088-.926-2.062-1.487-2.63-2.823-.421-.992-1.063-3.593-.262-4.8"
      stroke="#272C33"
      strokeWidth={1.45}
      strokeLinecap="round"
      strokeLinejoin="round"
    />

    <path
      d="M46.43 3.595c-.668-.395-6.822-3.889-14.341-2.077-1.712.413-3.081 1-4.037 1.48l.015.014c-4.67 1.373-7.427 4.608-9.132 8.14-3.202 6.626-1.534 11.168.498 14.577 2.273 3.808 10.97 13.685 11.737 13.862a20.94 20.94 0 0 0 6.19.494 20.7 20.7 0 0 0 8.623-2.154c1.52-.76 5.93-3.037 8.549-8.03 4.405-8.397-.089-17.2-.742-18.432-.741-1.399-2.833-5.214-7.356-7.878l-.004.004Z"
      stroke="#272C33"
      strokeWidth={1.354}
      strokeLinecap="round"
      strokeLinejoin="round"
    />

    <mask
      id="Memo_svg__a"
      style={{
        maskType: "luminance",
      }}
      maskUnits="userSpaceOnUse"
      x={18}
      y={7}
      width={18}
      height={37}
    >
      <path d="m35.232 7.58-.778 34.48-16.37 1.372V7.58h17.148Z" fill="#fff" />
    </mask>

    <g mask="url(#Memo_svg__a)">
      <path
        d="M34.535 43.434c-1.155-.04-2.893-.24-3.834-.484-1.737-.446-3.505-1.52-6.283-3.453-2.313-1.609-4.93-12.626-4.472-12.375a20.213 20.213 0 0 1 1.229-12.062c.716-1.652 1.671-3.232 3.007-4.442 1.841-1.668 4.302-2.535 6.767-2.86 2.464-.324 4.97-.15 7.449.023"
        fill="#fff"
      />
    </g>

    <path
      d="M31.177 42.185a27.076 27.076 0 0 1 3.749-.679c3.335-.358 6.117-.01 6.615-1.192.21-.498-.052-1.114.432-1.538.273-.24.513-.177.992-.476 0 0 .535-.207.82-.79.342-.704-.082-1.498.571-2.959 1.945-.27 3.708-1.649 4.383-3.48.27-.722.373-1.523.2-2.276-.174-.752-.65-1.45-1.336-1.804-.686-.354-1.587-.313-2.04-.063a20.214 20.214 0 0 0-1.229-12.06c-.716-1.654-1.671-3.233-3.007-4.443-1.841-1.668-4.302-2.535-6.767-2.86-2.464-.324-4.97-.151-7.449.022"
      fill="#fff"
    />

    <path
      d="M36.792 41.182c-.98.406-2.586.933-4.619.97-1.79.033-3.335-.32-4.261-.657-4.97-1.807-6.66-6.936-7.173-8.666 0 0-2.682-8.213-.066-17.611.266-.96.856-3.014 2.398-4.845a11.126 11.126 0 0 1 1.897-1.789s.981-.73 2.235-1.291c.86-.384 4.435-1.152 9.387-1.236"
      stroke="#272C33"
      strokeWidth={1.354}
      strokeLinecap="round"
      strokeLinejoin="round"
    />

    <path
      d="M43.807 38.866c-.45-1.73-.262-2.221.671-4.299 2.01-.276 3.83-1.704 4.53-3.597.277-.749.388-1.575.207-2.35-.18-.779-.671-1.498-1.38-1.864-.712-.365-1.638-.324-2.11-.062.266-2.328.65-7.93-1.786-12.973-1.317-2.73-2.859-4.048-3.217-4.343-1.693-1.405-3.368-1.926-4.616-2.302-3.74-1.125-6.991.037-9.275.49"
      stroke="#272C33"
      strokeWidth={1.354}
      strokeLinecap="round"
      strokeLinejoin="round"
    />

    <mask
      id="Memo_svg__b"
      style={{
        maskType: "luminance",
      }}
      maskUnits="userSpaceOnUse"
      x={22}
      y={19}
      width={6}
      height={4}
    >
      <path d="M27.27 19.656h-4.593v2.42h4.593v-2.42Z" fill="#fff" />
    </mask>

    <g mask="url(#Memo_svg__b)">
      <path
        d="M26.868 20.057a5.756 5.756 0 0 0-3.782 1.608"
        stroke="#272C33"
        strokeWidth={0.812}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>

    <mask
      id="Memo_svg__c"
      style={{
        maskType: "luminance",
      }}
      maskUnits="userSpaceOnUse"
      x={43}
      y={19}
      width={5}
      height={4}
    >
      <path d="M47.64 19.656h-4.593v2.42h4.594v-2.42Z" fill="#fff" />
    </mask>

    <g mask="url(#Memo_svg__c)">
      <path
        d="M43.453 20.057a5.755 5.755 0 0 1 3.781 1.608"
        stroke="#272C33"
        strokeWidth={0.812}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>

    <path
      d="M28.473 31.904a3.64 3.64 0 0 0 .007 1.454"
      stroke="#272C33"
      strokeWidth={1.081}
      strokeLinecap="round"
      strokeLinejoin="round"
    />

    <mask
      id="Memo_svg__d"
      style={{
        maskType: "luminance",
      }}
      maskUnits="userSpaceOnUse"
      x={23}
      y={26}
      width={4}
      height={5}
    >
      <path d="M23.142 26.576h2.963V30.3h-2.963v-3.723Z" fill="#fff" />
    </mask>

    <g mask="url(#Memo_svg__d)">
      <path
        d="M24.714 30.296c.768 0 1.39-.79 1.39-1.767 0-.976-.622-1.767-1.39-1.767-.768 0-1.391.791-1.391 1.767 0 .976.622 1.767 1.39 1.767Z"
        fill="#272C33"
      />

      <path
        d="M23.548 26.984c.155.17.306.34.461.506"
        stroke="#272C33"
        strokeWidth={0.812}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>

    <mask
      id="Memo_svg__e"
      style={{
        maskType: "luminance",
      }}
      maskUnits="userSpaceOnUse"
      x={34}
      y={26}
      width={4}
      height={5}
    >
      <path d="M37.79 26.576h-2.963V30.3h2.962v-3.723Z" fill="#fff" />
    </mask>

    <g mask="url(#Memo_svg__e)">
      <path
        d="M36.218 30.296c.768 0 1.39-.79 1.39-1.767 0-.976-.622-1.767-1.39-1.767-.769 0-1.391.791-1.391 1.767 0 .976.622 1.767 1.39 1.767Z"
        fill="#272C33"
      />

      <path
        d="M37.384 26.984c-.155.17-.307.34-.462.506"
        stroke="#272C33"
        strokeWidth={0.812}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>

    <path
      d="M41.95 23.038c-1.527-.229-5.168-.074-8.659-3.162-3.132-2.77-5.335-7.73-5.822-9.206-.232 1.61.056 5.291-2.029 8.258-2.922 4.158-4.01 5.52-5.549 6.077-.609-.613-.76-1.148-1.066-1.978-.277-.753.018-1.361-.074-2.159-.118-.992.162-2.925.347-3.91.125-.68.325-1.391.612-2.258.616-1.864 1.255-3.79 2.623-5.657 1.79-2.439 3.985-3.63 5.103-4.217 3.406-1.797 6.494-1.896 7.42-1.9a14.72 14.72 0 0 1 2.22.155c3.827.568 6.373 2.516 7.406 3.332 2.11 1.66 3.302 3.401 3.66 3.947 3.807 5.797 2.457 11.881 2.095 13.014-.125.395-.568 1.778-.785 1.734-.034-.008-.945.996-.956.97"
      fill="#2BA168"
    />

    <path
      d="M19.578 24.675c5.409-3.084 7.069-7.5 8.312-14.349a18.074 18.074 0 0 0 2.077 5.428c.561.963 1.694 2.87 3.841 4.615 2.734 2.218 6.217 2.83 7.855 3.107"
      stroke="#272C33"
      strokeWidth={1.354}
      strokeLinecap="round"
      strokeLinejoin="round"
    />

    <path
      d="M35.092 13.664a18.924 18.924 0 0 0 3.39 6.361c3.144 3.863 5.837 4.656 7.627 5.261"
      stroke="#272C33"
      strokeWidth={1.354}
      strokeLinecap="round"
      strokeLinejoin="round"
    />

    <path
      d="M18.183 64.482c-1.317 5.734-1.76 12.066-2.08 17.733"
      stroke="#272C33"
      strokeWidth={1.225}
      strokeMiterlimit={10}
      strokeLinecap="round"
    />

    <path
      d="M17.862 40.057c.214 1.38 1.284 2.475 2.125 2.785M15.475 40.725c.395 2.18 1.675 3.815 3.704 4.497"
      stroke="#272C33"
      strokeWidth={1.107}
      strokeLinecap="round"
      strokeLinejoin="round"
    />

    <path
      d="M28.163 36.465s.745.538 2.306.65c1.749.125 2.335-.322 2.335-.322"
      stroke="#272C33"
      strokeWidth={1.059}
      strokeLinecap="round"
      strokeLinejoin="round"
    />

    <path
      d="M14.823 57.409a1.476 1.476 0 1 0-2.862.721l2.473 9.807a1.476 1.476 0 1 0 2.862-.722l-2.473-9.806Z"
      stroke="#272C33"
      strokeWidth={1.476}
      strokeLinecap="round"
      strokeLinejoin="round"
    />

    <path
      d="m26.277 86.496-14.2-1.033a1.842 1.842 0 0 1-1.823-1.568L6.893 66.68c-.17-1.118 1.719-2.833 2.848-2.833H26.82c1.302.122 2.431.874 2.693 2.073l2.715 20.212c.17 1.118-4.822.369-5.95.369v-.004Z"
      fill="#fff"
      stroke="#272C33"
      strokeWidth={1.107}
      strokeLinecap="round"
      strokeLinejoin="round"
    />

    <path
      d="M28.735 86.752H10.782a1.842 1.842 0 0 1-1.823-1.568L6.623 67.26a1.843 1.843 0 0 1 1.823-2.121h17.953c.912 0 1.686.664 1.823 1.568l2.335 17.924a1.843 1.843 0 0 1-1.822 2.121Z"
      fill="#fff"
      stroke="#272C33"
      strokeWidth={1.107}
      strokeLinecap="round"
      strokeLinejoin="round"
    />

    <path
      d="M11.357 67.557h-1.332a.793.793 0 0 0-.794.793v.004c0 .438.356.793.794.793h1.332a.793.793 0 0 0 .793-.793v-.004a.793.793 0 0 0-.793-.793Z"
      fill="#272C33"
    />
  </svg>
);

const Memo = memo(SvgMemo);

export default Memo;
